export default __webpack_public_path__ + "static/media/restaurant.ea05ec83.png";